export function LoadingPanel({ label }: { label: string }) {
  return <section className="panel narrow"><p>{label}</p></section>;
}
